import React from 'react';
import ReactDOM from 'react-dom/client';
import { useLocation } from 'react-router';
import './index.css';
import App from './App';
import Login from './Login'
import Main from './Main'
import Agapp from './Agapp';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalState, { useGlobalState } from './GlobalState';
import { BrowserRouter } from 'react-router-dom';
/*const root1 = ReactDOM.createRoot(document.getElementById('root'));
root1.render(
  <GlobalState>
    <Router>
      <App />
    </Router>
  </GlobalState>
);*/
document.documentElement.style.setProperty(
  '--enterprise-color',
  process.env.REACT_APP_ENTERPRISE_COLOUR
);
document.documentElement.style.setProperty(
  '--enterprise-color-dark',
  process.env.REACT_APP_ENTERPRISE_COLOUR_DARK
);
document.documentElement.style.setProperty(
  '--enterprise-color-tertiary',
  process.env.REACT_APP_ENTERPRISE_COLOUR_TERTIARY
);

document.documentElement.style.setProperty(
  '--enterprise-color-button',
  process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON
);

const brand = process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE || "Logistics";
const favicon = `${process.env.PUBLIC_URL}/assets/${brand}/browser_tab.png`;

const updateFavicon = (href) => {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/png";
    document.head.appendChild(link);
  }
  link.href = href;
};

updateFavicon(favicon);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <GlobalState>
    <Agapp/>
  </GlobalState>
  </BrowserRouter>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
